export enum ClientCategory {
  VIP = 'VIP',
  STANDART = 'STANDART',
}
